import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThematicPortfoliosComponent } from 'src/app/pages/thematic-portfolios/thematic-portfolios.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

const routes: Routes = [
  {
    path: '',
    component: ThematicPortfoliosComponent,
    canActivate: [AuthenticationService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ThematicPortfoliosRoutingModule { }
